// This is a magic string replaced by rollup

const SDK_VERSION = "9.47.1" ;

export { SDK_VERSION };
